import { getInsectIdFromValueGroup } from '@semios/app-platform-common'
import type { TPermission, VV } from '@semios/app-platform-value-type-definitions'
import {
  TAggregationRequestedValue,
  VIEW_PESTS_TRAP_CATCHES_ID_insectId,
} from '@semios/app-platform-value-type-definitions'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import type {
  doesSelectedBlockHaveValueTypes,
  doesSelectedPropertyHaveValueTypes,
  doesSelectedRegionHaveValueTypes,
} from 'utils/doesSelectedFieldAssetHaveValueTypes'
import type { getTrapPercentageValueTypeIdForInsectId } from './getValueTypesForInsectId'
import { getTrapValueTypeIdForInsectId } from './getValueTypesForInsectId'

const preferredAggregationInterval = {
  preferredAggregationInterval: 'DAILY',
} satisfies TAggregationRequestedValue

export const getInsectTrapCatchesValuesRequested = ({
  selectedValueGroups,
  doesTargetHaveValueTypes,
  permissionCheck,
  getTrapValueTypeFunction = getTrapValueTypeIdForInsectId,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
  doesTargetHaveValueTypes:
    | typeof doesSelectedPropertyHaveValueTypes
    | typeof doesSelectedRegionHaveValueTypes
    | typeof doesSelectedBlockHaveValueTypes
  permissionCheck: (permissionId: TPermission) => boolean
  getTrapValueTypeFunction?:
    | typeof getTrapValueTypeIdForInsectId
    | typeof getTrapPercentageValueTypeIdForInsectId
}) => {
  const valuesRequested: Partial<
    Record<
      VV.DomainTypes.TrapCatchesInsect.TTimeseriesValueTypeKeysMerged,
      typeof preferredAggregationInterval
    >
  > = {}

  Object.entries(selectedValueGroups).forEach(([valueGroup, isActive]) => {
    if (!!isActive && valueGroup.includes('trap_catches_insect_id_')) {
      const insectId = getInsectIdFromValueGroup(valueGroup)

      if (!insectId || !permissionCheck(VIEW_PESTS_TRAP_CATCHES_ID_insectId(insectId))) return

      const valueType = getTrapValueTypeFunction(insectId)

      // TODO: Sara has a fix for this in a future PR - it's an issue with blocks vs regions vs properties not having same value types
      //@ts-ignore
      if (!doesTargetHaveValueTypes({ valuesTimeseries: [valueType] })) return

      valuesRequested[valueType] = preferredAggregationInterval
    }
  })

  return valuesRequested
}
